import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";

import { MdCardMembership, MdOutlineAirplanemodeActive } from "react-icons/md";
import { BsCashCoin } from "react-icons/bs";
import { MdStars } from "react-icons/md";
import { BsFillFuelPumpFill } from "react-icons/bs";
import { FaBriefcase, FaInfinity } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import FAQSchema from "../../FAQSchema";
import { motion } from "framer-motion";
import {
  FaListAlt,
  FaRegCreditCard,
  FaWpforms,
  FaRegCheckCircle,
  FaFileAlt,
  FaUserCheck,
  FaShippingFast,
} from "react-icons/fa";
import {
  FaSearch,
  FaFileUpload,
  FaEdit,
  FaHourglassHalf,
  FaCreditCard,
  FaExchangeAlt,
  FaPercent,
  FaMoneyBillWave,
  FaGlobe,
  FaGift,
  FaChartBar,
} from "react-icons/fa";

import {
  FaMedal,
  FaRegHandshake,
  FaHotel,
  FaReceipt,
  FaLayerGroup,
  FaGlobeAmericas,
  FaPhoneAlt,
  FaUtensils,
  FaGasPump,
} from "react-icons/fa";
import {
  FaMoneyCheckAlt,
  FaClipboardCheck,
  FaBalanceScale,
  FaWallet,
  FaTags,
} from "react-icons/fa";
import { FaShieldAlt, FaPlaneDeparture, FaCoins } from "react-icons/fa";
import { BadgeCheck, FileText } from "lucide-react";
function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${
        id === open ? "rotate-180" : ""
      } h-5 w-5 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}
const RewardCredit = () => {
  const [CreditCardData, setCreditCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(10);
  // const location = useLocation()
  // console.log(location.state)
  useEffect(() => {
    Http.post(CARD_API)
      .then((res) => {
        setCreditCardData(res);
        // console.log("Card API Response:", res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  console.log({ indexOfLastCard, indexOfFirstCard });
  const currentCards = CreditCardData.cards
    ?.filter((cards) => cards.category_name === "Reward")
    .slice(indexOfFirstCard, indexOfLastCard);
  console.log({ currentCards });

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const [activeIndex, setActiveIndex] = useState(0);

  const faqs = [
    {
      question: "What is a rewards credit card?",
      answer:
        "A rewards credit card offers incentives such as points, cashback, or miles for every purchase you make.",
    },
    {
      question: "How do I earn rewards with a rewards credit card?",
      answer:
        "You earn rewards by making purchases with the card, with higher rewards for certain categories.",
    },
    {
      question: "Can I redeem my rewards for cash?",
      answer:
        "Yes, many rewards cards allow you to redeem points for cash or statement credit.",
    },
    {
      question: "What is the sign-up bonus?",
      answer:
        "The sign-up bonus is a reward you receive after meeting a spending threshold within the first few months of using the card.",
    },
    {
      question: "How long does it take to redeem rewards?",
      answer:
        "Redemption can vary, but most programs allow you to redeem rewards immediately or after accumulating a certain number of points.",
    },
    {
      question: "Is there an annual fee for a rewards credit card?",
      answer:
        "Most rewards cards charge an annual fee, but this is often offset by the rewards you earn.",
    },
    {
      question: "Can I use my rewards for travel expenses?",
      answer:
        "Yes, many rewards cards offer travel benefits like airline miles, hotel discounts, or free lounge access.",
    },
    {
      question: "What happens if I don’t pay my balance on time?",
      answer:
        "Late payments may incur interest charges and potentially affect your credit score.",
    },
    {
      question: "Are rewards points transferable?",
      answer:
        "Some credit cards allow you to transfer points to airline or hotel loyalty programs.",
    },
    {
      question: "Do I need a good credit score to apply?",
      answer:
        "Yes, a good credit score is usually required to qualify for a rewards credit card.",
    },
    {
      question: "Can I earn rewards on every purchase?",
      answer:
        "Yes, but the rate of earning rewards may vary depending on the type of purchase.",
    },
    {
      question: "What is the minimum spending requirement to earn rewards?",
      answer:
        "There’s no minimum spending requirement to earn rewards, but you typically need to spend a certain amount to get sign-up bonuses.",
    },
    {
      question: "Are there any foreign transaction fees?",
      answer:
        "Some rewards cards charge foreign transaction fees, while others offer no-fee options.",
    },
    {
      question: "Can I use rewards for online shopping?",
      answer:
        "Many programs allow you to redeem rewards for online shopping through partner retailers.",
    },
    {
      question: "How are rewards points calculated?",
      answer:
        "Points are usually awarded as a percentage of your spending, with bonus points for specific categories.",
    },
    {
      question: "Can I apply for a rewards credit card online?",
      answer: "Yes, most issuers offer an online application process.",
    },
    {
      question: "What happens if I lose my rewards credit card?",
      answer:
        "Contact your card issuer immediately to block the card and prevent unauthorized transactions.",
    },
    {
      question: "Can rewards points expire?",
      answer:
        "Yes, some rewards points may have an expiration date, while others may not.",
    },
    {
      question: "Is there a cap on the rewards I can earn?",
      answer:
        "Some cards may limit the number of points you can earn in specific categories.",
    },
    {
      question: "Can I upgrade my card to a rewards card?",
      answer:
        "Depending on the issuer, you may be able to upgrade your existing card to a rewards credit card.",
    },
  ];

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };

  const steps = [
    {
      icon: <FaSearch className="h-6 w-6 text-blue-600" />,
      title: " Research Your Options",
      description:
        "  Start by comparing different reward credit cards based on the rewards program, annual fees, interest rates, and bonus offers.",
    },
    {
      icon: <FaUserCheck className="h-6 w-6 text-amber-500" />,
      title: "Check Your Eligibility",
      description:
        "  Ensure you meet the eligibility criteria, such as minimum income, credit score, and age requirements.",
    },
    {
      icon: <FaFileUpload className="h-6 w-6 text-purple-600" />,
      title: ". Gather Required Documents",
      description:
        "  Prepare necessary documents like proof of identity, address, income, and any other relevant paperwork.",
    },
    {
      icon: <FaEdit className="h-6 w-6 text-teal-500" />,
      title: "Fill Out the Application Form ",
      description:
        " Submit your application online or offline, filling in your personal details, employment information, and any other requested data.",
    },

    {
      icon: <FaHourglassHalf className="h-6 w-6 text-pink-500" />,
      title: " Wait for Approval",
      description:
        "  The bank will evaluate your application, checking your credit history and financial standing before approving or rejecting your request.",
    },

    {
      icon: <FaCreditCard className="h-6 w-6 text-green-500" />,
      title: "Receive Your Card",
      description:
        "  Once approved, your rewards credit card will be sent to your address. Follow the instructions to activate it.",
    },
  ];
  const benefits = [
    {
      icon: <FaShieldAlt className="text-3xl text-amber-600" />,
      title: "  Enhanced Security",
      description:
        "With credit cards, you enjoy additional security features such as fraud protection and dispute resolution. Your liability in case of fraudulent transactions is often limited.",
    },

    {
      icon: <FaGift className="text-3xl text-purple-600" />,
      title: "Sign-Up Bonus",
      description:
        "  Most rewards credit cards offer a sign-up bonus when you meet a certain spending threshold within the first few months. This is an excellent way to kick-start your rewards journey.",
    },
    {
      icon: <FaPlaneDeparture className="text-3xl text-pink-500" />,
      title: "Travel Perks",
      description:
        "  Many reward cards offer travel-related benefits such as free airport lounge access, frequent flyer miles, discounts on flights, and hotel bookings. Ideal for frequent travelers, this feature enhances the overall experience of your trips.",
    },
    {
      icon: <FaTags className="text-3xl text-yellow-500" />,
      title: " Exclusive Offers and Discounts",
      description:
        "  Cardholders are often entitled to special promotions and discounts with partner merchants, such as restaurants, retail stores, and e-commerce websites. These can add up to great savings over time.",
    },

    {
      icon: <FaCoins className="text-3xl text-red-500" />,
      title: "  Earning Points or Cashback",
      description:
        "  Every time you make a purchase, you earn rewards points or cashback. These can accumulate quickly, offering you valuable benefits. For frequent spenders, this can translate to significant savings or rewards.",
    },
  ];

  const factors = [
    {
      icon: FaChartBar,
      title: "Reward Structure",
      desc: "   Look for cards that offer higher rewards for your spending categories, such as dining, travel, or groceries. A good rewards structure ensures you earn more for the categories you spend the most in.",
    },
    {
      icon: FaGift,
      title: " Sign-Up Bonus",
      desc: "  Many credit cards offer substantial sign-up bonuses. Compare these offers to ensure you’re getting maximum value when you start using your card.",
    },

    {
      icon: FaGlobe,
      title: "International Acceptance & Forex Markups",
      desc: " If you’re a frequent traveler or shop online from international platforms, check whether your premium card is widely accepted globally. Also, look at the foreign transaction markup fees—lower markups (1.5%-2.5%) help you save significantly on international spends compared to standard cards that typically charge 3.5%.",
    },
    {
      icon: FaMoneyBillWave,
      title: "Annual Fee",
      desc: "  Consider the card’s annual fee relative to the benefits. Some cards may offer excellent rewards but charge high fees, so weigh this factor carefully.",
    },
    {
      icon: FaPercent,
      title: "Interest Rates",
      desc: "   Pay attention to the interest rates on purchases, cash advances, and balance transfers. Lower rates are preferable, especially if you tend to carry a balance.",
    },
    {
      icon: FaExchangeAlt,
      title: "Redemption Options",
      desc: "   Ensure the rewards program offers a variety of redemption options. Whether it’s travel, merchandise, or cashback, choose a card that offers flexibility in how you can use your rewards.",
    },
    {
      icon: FaMoneyCheckAlt,
      title: "Foreign Transaction Fees",
      desc: "  If you travel internationally, a card with no foreign transaction fees can be highly beneficial. This helps you save on extra charges when making purchases abroad.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>
          Best Premium Credit Cards in India 2024 - Exclusive Benefits
        </title>
        <meta
          name="description"
          content="Best Premium Credit Cards in India - Check Best Premium Credit Cards Available in India. Compare & Apply now for the Most Prestigious with Benefits."
        />
        <meta
          name="keywords"
          content="premium credit cards, american express platinum charge card, axis bank premium credit card, sbi premium credit card, hdfc bank premium credit card, icici bank premium credit card"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/credit-card/best-premium-credit-card"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      <div className="w-full flex flex-col items-center ">
        <div className=" mt-10 w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600">
          <h1 className="text-white text-4xl md:text-7xl text-center font-medium">
            Reward Credit Card
          </h1>
          <p className="text-gray-200 text-lg md:text-2xl pt-2 px-4 text-center">
            Experience financial freedom and flexibility with our credit card
            options.
          </p>
        </div>

        <div className="flex flex-wrap   justify-center gap-4 lg:gap-6 mt-4">
          <Link
            to="/credit-card/best-cashback-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <BsCashCoin className="mr-2 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Cash Back
              </span>
            </span>
          </Link>

          <Link
            to="/credit-card/travel-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <MdOutlineAirplanemodeActive className="mr-4 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Travel
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/fuel-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <BsFillFuelPumpFill className="mr-4 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Fuel
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/best-lifetime-free-credit-cards"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <FaInfinity className="mr-4 text-2xl text-black" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Lifetime Free
              </span>
            </span>
          </Link>
          
                    <Link
                      to="/credit-card/business-credit-card"
                      className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
                    >
                      <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
                      <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
                        <svg
                          class="w-5 h-5 text-green-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                          ></path>
                        </svg>
                      </span>
                      <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
                        <svg
                          class="w-5 h-5 text-green-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                          ></path>
                        </svg>
                      </span>
                      <span className="relative flex items-center">
                        <FaBriefcase className="mr-1 text-black text-2xl" />{" "}
                        <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                        Business
                        </span>
                      </span>
                    </Link>
                    <Link
                      to="/credit-card/lifestyle-credit-card"
                      className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
                    >
                      <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
                      <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
                        <svg
                          class="w-5 h-5 text-green-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                          ></path>
                        </svg>
                      </span>
                      <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
                        <svg
                          class="w-5 h-5 text-green-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                          ></path>
                        </svg>
                      </span>
                      <span className="relative flex items-center">
                        <MdCardMembership className="mr-1 text-black text-2xl" />{" "}
                        <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                          LifeStyle
                        </span>
                      </span>
                    </Link>
                    <Link to="/credit-card/best-premium-credit-card"  className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group">
                    <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
                    <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
                    <svg class="w-5 h-5 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
                    </span>
                    <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
                    <svg class="w-5 h-5 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
                    </span>
                    <span className="relative flex items-center"><MdStars className="mr-1 text-black text-2xl" /> <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">Premium</span></span>
                    </Link>
               
        </div>

         
        <h1 className="text-center font-bold text-2xl md:text-3xl  my-10">
          Featured Credit Cards
        </h1>
        <div className="w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10">
          <div className="w-fit flex flex-col gap-8">
            {currentCards &&
              currentCards.map((item, index) => {
                return (
                  <>
                    {" "}
                    <CardComponent
                      key={index}
                      cardDetails={item}
                      Card_features={item?.Card_features}
                      fees={item?.fees}
                      cardName={item?.title}
                      cardImage={item?.image}
                      rating={item?.rating}
                      category={item?.category}
                      status={item?.status}
                      bank_link={item?.bank_link}
                    />{" "}
                  </>
                );
              })}
          </div>

          <div className="w-full relative ">
            <div className="sticky overflow-hidden top-20 w-full h-[350px] flex flex-col justify-between">
              {/* <div className="w-[70%] mx-auto">
                                                <h2 className="text-center font-medium pt-5 text-lg">
                                                  <span className="font-semibold text-white">816 people</span>{" "}
                                                  are on call with our advisors right now
                                                </h2>
                                              </div> */}
              <div className="w-full mx-auto">
                <Link
                  to="https://play.google.com/store/apps/details?id=com.popclub.android&pcampaignid=web_share"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="w-[80%] mx-auto ">
                    <img
                      src="/assets/ppp.png"
                      alt="Advertisement"
                      target="_blank"
                      rel="noopener noreferrer"
                    />
                  </div>
                </Link>
                <div className="bg-white">
                  {/* <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                                                    Know your advisor
                                                  </h3> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Pagination */}
        <ul className="flex justify-center mt-4">
          {currentCards &&
            CreditCardData.cards?.filter(
              (card) => card.category === "Credit card"
            ).length > 0 &&
            Math.ceil(
              CreditCardData.cards?.filter(
                (card) => card.category === "Credit card"
              ).length / cardsPerPage
            ) > 1 &&
            Array.from({
              length: Math.ceil(
                CreditCardData.cards?.filter(
                  (card) => card.category === "Credit card"
                ).length / cardsPerPage
              ),
            }).map((_, index) => (
              <li key={index} className="mx-1">
                <button
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>
      </div>

      <div className="flex justify-center items-center  p-4 mt-6">
        <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center ">
          <h2 className="text-2xl md:text-3xl  font-bold text-gray-800 ">
            What is a Rewards Credit Card?
          </h2>
          <p className="text-gray-600 leading-relaxed">
            A Rewards Credit Card is a financial product that allows you to earn
            points, cashback, or other perks in exchange for your everyday
            spending. These cards reward you for making purchases, which can
            then be redeemed for travel, merchandise, gift cards, or even cash.
            The value of rewards earned depends on the type of card, spending
            patterns, and the redemption options offered by the issuer. Whether
            you use it for grocery shopping, dining out, or online shopping, a
            rewards credit card enhances your purchasing experience by offering
            tangible benefits in return.
          </p>
        </div>
      </div>

      <div className="px-4 py-6 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-4">
          📝 How to Apply For a Rewards Credit Card
        </h2>
        {/* <p className="text-gray-600 text-sm md:text-base mt-2 text-center mb-8">
          Applying for a Premium Credit Card is an easy yet
          eligibility-dependent process. Here's how to go about it:
        </p> */}
        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start gap-4 p-4 rounded-xl bg-white dark:bg-gray-900 shadow-md border hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mt-1">{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{`${
                  index + 1
                }. ${step.title}`}</h3>
                <p className="text-md text-gray-600 dark:text-gray-300">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      <div className="w-full px-2 py-6 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
        <div className="max-w-6xl mx-auto grid gap-10">
          <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
            <div className="flex items-center gap-3 mb-6">
              <FileText className="w-8 h-8 text-sky-600" />
              <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                Documents Required to Apply for a Rewards Credit Card
              </span>
            </div>
            <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block  text-gray-800 dark:text-white">
                  Passport-sized photo for identity verification.
                </span>
                {/* <span> PAN card, Aadhaar card, or passport.</span> */}
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block  text-gray-800 dark:text-white">
                  Utility bill, bank statement, or rental agreement.
                </span>
                {/* <span> Utility bills, rental agreement, or Aadhaar card.</span> */}
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block  text-gray-800 dark:text-white">
                  Recent salary slips, bank statements, or tax returns.
                </span>
                {/* <span>  Latest salary slips (for salaried individuals), ITR or bank statements (for self-employed).
                    </span> */}
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block  text-gray-800 dark:text-white">
                  Government-issued ID such as Aadhar card, passport, or
                  driver’s license.
                </span>
                {/* <span> Passport-sized photo as required by the issuer.</span> */}
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block  text-gray-800 dark:text-white">
                  For salaried individuals, employment letter or salary account
                  statements may be required.
                </span>
                {/* <span> Passport-sized photo as required by the issuer.</span> */}
              </div>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
            <div className="flex items-center gap-3 mb-6">
              <BadgeCheck className="w-8 h-8 text-emerald-600" />
              <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                Eligibility Required to Get a Rewards Credit Card
              </span>
            </div>
            <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block  text-gray-800 dark:text-white">
                  Applicants must be at least 21 years old.
                </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block  text-gray-800 dark:text-white">
                  A good credit score, usually 750 and above, is preferred.
                </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block  text-gray-800 dark:text-white">
                  Either salaried or self-employed individuals can apply.{" "}
                </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block  text-gray-800 dark:text-white">
                  A minimum monthly income, typically ₹25,000 and above (varies
                  by issuer).
                </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl sm:col-span-2">
                <span className="block  text-gray-800 dark:text-white">
                  Applicants must be residents of the country or have a valid
                  address in the country.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="px-4 py-6 md:px-8 max-w-7xl mx-auto mt-4">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 text-center mb-10">
          Benefits of a Rewards Credit Card
        </h2>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {benefits.map((item, idx) => (
            <div
              key={idx}
              className="bg-white shadow-md rounded-xl p-6 flex flex-col items-start gap-4 hover:shadow-xl transition duration-300"
            >
              {item.icon}
              <h3 className="text-xl font-semibold">{item.title}</h3>
              <p className="text-gray-600 text-md">{item.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-6">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-6">
          How to Choose the Best Rewards Credit Card - Key Factors to Consider{" "}
        </h2>
        {/* <p className="text-gray-600 text-base md:text-lg text-center max-w-2xl mx-auto mb-12">
    Selecting the right fuel credit card goes beyond just fuel discounts. It’s about ensuring consistent savings, ease of use, and long-term value. Here are the key elements to evaluate before making your choice:
  </p> */}

        <div className="space-y-10 divide-y divide-gray-300">
          {factors.map((item, index) => (
            <div key={index} className="flex items-start gap-5 pt-8">
              <div className="text-blue-600 shrink-0">
                <item.icon size={32} className="mt-1.5" />
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-base leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 py-6 text-gray-800">
        {/* Section Title */}
        {/* Section Title */}
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-6">
          Why Opt for a Rewards Credit Card?
        </h2>

        <p className="text-base md:text-md text-center mb-14 max-w-4xl mx-auto text-gray-800">
          A rewards credit card is perfect for individuals who make regular
          purchases and want to make their spending more rewarding. Frequent
          travelers, shoppers, and those who regularly dine out or buy groceries
          will find significant benefits. If you're financially disciplined and
          can pay off your balance every month, a rewards card maximizes your
          return on spending. The value of the rewards increases when you
          consistently use the card for everyday expenses, helping you redeem
          rewards like travel, shopping discounts, and more.
        </p>

        {/* Comparison Table */}
        <h3 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Comparison Between Rewards Credit Card and Normal Credit Cards
        </h3>
        {/* Styled Table */}
        <div className="overflow-x-auto w-full">
          <table className="min-w-[600px] border-separate border-spacing-y-2 text-left text-base text-gray-700">
            {/* Mobile-Friendly Table Alternative */}
            <div className="space-y-6 md:hidden">
              {[
                [
                  "Rewards Program",
                  "Earn points, cashback, or miles for every purchase",
                  "No rewards or limited rewards",
                ],
                [
                  "Annual Fee",
                  "May have a higher fee, but often outweighed by rewards",
                  "Typically lower annual fees",
                ],
                [
                  "Interest Rate",
                  "Similar to regular cards, but can vary by issuer",
                  "Similar to rewards cards",
                ],
                [
                  "Perks",
                  "Travel perks, exclusive discounts, sign-up bonuses",
                  "Basic features, no additional perks",
                ],
                [
                  "Suitability",
                  "Ideal for those who spend often and want to earn rewards",
                  "Best for occasional users who do not prioritize rewards",
                ],
              ].map(([feature, fuel, regular], i) => (
                <div
                  key={i}
                  className="border rounded-xl p-4 shadow-sm bg-white"
                >
                  <p className="font-semibold text-gray-800 mb-2">{feature}</p>
                  <div className="text-sm text-gray-700">
                    <p>
                      <span className="font-semibold">
                        Rewards Credit Card:
                      </span>{" "}
                      {fuel}
                    </p>
                    <p>
                      <span className="font-semibold">Normal Credit Card:</span>{" "}
                      {regular}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Desktop Table */}
            <div className="hidden md:block overflow-x-auto">
              <table className="min-w-full border-separate border-spacing-y-2 text-left text-base text-gray-700">
                <thead className="bg-blue-50 text-gray-800">
                  <tr>
                    <th className="px-4 py-3 font-semibold">Feature</th>
                    <th className="px-4 py-3 font-semibold">
                      Premium Credit Card
                    </th>
                    <th className="px-4 py-3 font-semibold">
                      Normal Credit Card
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    [
                      "Rewards Program",
                      "Earn points, cashback, or miles for every purchase",
                      "No rewards or limited rewards",
                    ],
                    [
                      "Annual Fee",
                      "May have a higher fee, but often outweighed by rewards",
                      "Typically lower annual fees",
                    ],
                    [
                      "Interest Rate",
                      "Similar to regular cards, but can vary by issuer",
                      "Similar to rewards cards",
                    ],
                    [
                      "Perks",
                      "Travel perks, exclusive discounts, sign-up bonuses",
                      "Basic features, no additional perks",
                    ],
                    [
                      "Suitability",
                      "Ideal for those who spend often and want to earn rewards",
                      "Best for occasional users who do not prioritize rewards",
                    ],
                  ].map(([feature, fuel, regular], i) => (
                    <tr
                      key={i}
                      className={i % 2 === 0 ? "bg-white" : "bg-gray-50"}
                    >
                      <td className="px-4 py-3 font-medium">{feature}</td>
                      <td className="px-4 py-3">{fuel}</td>
                      <td className="px-4 py-3">{regular}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </table>
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h1 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h1>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default RewardCredit;
